// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { put } from '@tls/auth';

/**
 * @param {String} projectId
 * @param {String} imageMd5
 * @param {Bool} validationData
 * @param {Number} qcResult 'unknown=-1' bad='0' good='1' ... oder so
 */
export async function postMaskMeta(projectId, imageMd5, validationData, qcResult) {
  const url = `projects/${projectId}/labels/${imageMd5}/mask/meta`;
  const response = await put(url, { validationData, qcResult });

  if (response.status !== 200) {
    throw new Error('Failed to update mask meta');
  }

  return await response;
}

export async function postImageMeta(projectId, imageMd5, tags) {
  const url = `projects/${projectId}/labels/${imageMd5}/meta`;
  const response = await put(url, tags);
  if (response.status !== 200) {
    throw new Error('Failed to update image meta');
  }

  return await response;
}
